exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".archival-warning {\n  margin-bottom: 12px;\n}\n\n.relationship-check {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-bottom: 12px;\n}\n\n.relationship-check span {\n  margin-left: 8px;\n}\n\n.relationship-warning {\n  margin-bottom: 12px;\n}\n\n.related-entities {\n  margin: 8px 0 0 16px;\n  max-height: 120px;\n  overflow-y: auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/archival/archivalconfirm/archival-confirm.component.css
// module id = 1913
// module chunks = 0